import React, {useEffect, useState} from "react"

import Iamport from 'react-iamport';


import "../../page/Shop/Shop.css"

import ShopProgress from "./ShopProgress"
import {numberWithCommas, sendRequest} from "../../common";
import {useParams} from "react-router-dom";

function OrderPay({orderProducts, user, setStep, imp_success}) {

	const noVatPrice = orderProducts.filter(item => !item?.product?.vat).map(item => item?.product?.price * item?.quantity).reduce((prev, curr) => prev + curr, 0)
	const onVatPrice = orderProducts.filter(item => !!item?.product?.vat).map(item => item?.product?.price * item?.quantity).reduce((prev, curr) => prev + curr, 0)
	const vatPrice = orderProducts.filter(item => !!item?.product?.vat).map(item => item?.product?.vat * item?.quantity).reduce((prev, curr) => prev + curr, 0)
	const totalPrice = noVatPrice + onVatPrice + vatPrice

	const merchant_uid = 'merchant_' + new Date().getTime()
	const orderNumber = merchant_uid.replace('merchant_', '')

	const onPaid = (res) => {
		if (res.success) {
			saveAllOrderProducts(orderProducts, 0, [], res, '결제완료')
		}
	}

	const saveAllOrderProducts = (orderProducts, index, ids, res, status) => {
		if (orderProducts?.length - 1 < index) {
			saveOrder(ids, res, status)
			return
		}
		sendRequest('order/product/', 'POST', {
			product: orderProducts[index]?.product?.id,
			quantity: orderProducts[index]?.quantity
		}, data => {
			ids.push(data?.id)
			saveAllOrderProducts(orderProducts, index + 1, ids, res, status)
		})
	}

	const saveOrder = (orderProductIds, res, status) => {
		sendRequest('order/order/', 'POST', {
			orderProducts: orderProductIds,
			orderNumber,
			status
		}, data => {
			savePayment(data?.id, res, status)
		})
	}

	const savePayment = (orderId, res, status) => {
		sendRequest('order/payment/', 'POST', {
			order: orderId,
			price: totalPrice,
			type: 'card',
			resultCode: status === '결제대기' ? 'paying' : 'paid',
			paymentNumber: res.pg_tid,
		}, data => {
			setStep(4)
			console.log('success payment!')
		})
	}

	return (
		<>
			<div className="cardContent orderPay">
				<form name="orderPayment">
					<ShopProgress isLast={true} />
					<section>
						<h4>주문 목록</h4>
						<div className="shopTableWrap">
							<table className="shopTable">
								<colgroup>
									<col width="50%" />
									<col width="15%" />
									<col width="10%" />
									<col width="15%" />
									<col width="10%" />
								</colgroup>
								<thead>
									<tr>
										<th>상품명</th>
										<th>금액</th>
										<th>수량</th>
										<th>주문금액</th>
										<th>부가세</th>
									</tr>
								</thead>
								<tbody>
									{orderProducts?.map((item, index) => {
										return (
											<tr>
												<td>
													<div className="itemName">
														<span>【{item?.product?.group}】 {item?.product?.name}</span>
														{item?.proudct?.desc}
													</div>
												</td>
												<td className="itemPrice">{numberWithCommas(item?.product?.price)}원</td>
												<td>{item?.quantity}</td>
												<td className="orderPrice">{numberWithCommas(item?.product?.price * item?.quantity)}원</td>
												<td className="itemTax">{!item?.product?.vat ? '면세' : numberWithCommas(item?.product?.vat)}</td>
											</tr>
										)
									})}

								</tbody>
							</table>
						</div>
					</section>
					<section>
						<h4>최종 결제 금액 확인</h4>
						<ul className="payList">
							<li>
								<b>면세상품 금액</b> <span>{numberWithCommas(noVatPrice)}원</span>
							</li>
							<li>
								<b>과세 상품 금액</b> <span>{numberWithCommas(onVatPrice)}원</span>
							</li>
							<li>
								<b>부가가치세</b> <span>{numberWithCommas(vatPrice)}원</span>
							</li>
						</ul>
						<div className="totalPay">
							<span>합계</span>
							<b>{numberWithCommas(totalPrice)}원</b>
						</div>
					</section>
					<Iamport
						identificationCode="imp26013182"
						params={{
							pg: 'html5_inicis.MOIhcpts01',
							pay_method: 'card',
							merchant_uid: merchant_uid,
							name: '주문명:온라인심리검사',
							amount: totalPrice,
							buyer_email: user?.email,
							buyer_name: user?.name,
							buyer_tel: user?.phone,
							buyer_addr: '',
							buyer_postcode: '',
							m_redirect_url: `https://hcpts.net/purchase-online/?step=4&orderNumber=${orderNumber}`,
						}}
						onFailed={err => console.log(err)}
						onCompleted={res => {alert(res)}}
						onSuccess={onPaid}
						jqueryLoaded={false}
						render={(renderProps) => (
							<div className="shopBtnWrap">
								<button type="submit" onClick={(e) => {
									e.preventDefault()
									if (window.innerWidth <= 500) {
										saveAllOrderProducts(orderProducts, 0, [], {merchant_uid}, '결제대기')
									}
									setTimeout(renderProps.onClick, 300)
								}}>결제하기</button>
							</div>
						)}
					/>
				</form>
			</div>
		</>
	)
}

export default OrderPay
